export function fmtMoney(v, withSymbol = true) {
  const n = Number(v ?? 0);
  const s = n.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return withSymbol ? `R ${s}` : s;
}

export function fmtNum(v, dp = 2) {
  return Number(v ?? 0).toLocaleString("en-ZA", { minimumFractionDigits: dp, maximumFractionDigits: dp });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-ZA", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
      timeZone: "Africa/Johannesburg",
    });
  } catch { return iso; }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-ZA", {
      day: "2-digit", month: "short", year: "numeric", timeZone: "Africa/Johannesburg",
    });
  } catch { return iso; }
}

export function fmtTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleTimeString("en-GB", {
      hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Africa/Johannesburg",
    });
  } catch { return iso; }
}

export function fmtDuration(minutes) {
  const m = Number(minutes || 0);
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h && mm) return `${h}h ${mm}m`;
  if (h) return `${h}h`;
  return `${mm}m`;
}

export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  accepted: "bg-green-50 text-green-700 border-green-200",
  completed: "bg-blue-50 text-blue-700 border-blue-200",
  declined: "bg-red-50 text-red-700 border-red-200",
  archived: "bg-amber-50 text-amber-700 border-amber-200",
  deleted: "bg-slate-100 text-slate-400 border-slate-200",
};
